import { NODE, RELATION, ATTRIBUTE_VIEW, RELATION_VIEW, ATTRIBUTES, RELATION_NODE, QUERY, VIEWTYPE } from 'Types'
import { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { ContextMenu, GraphConsole, Loading, Graph, WeWeVr } from 'Components'
import { useCancelable, useComponentIsMountedRef, useQuery } from 'Hooks'
import { getQueryFromCurrentItem } from '../helpers'
import { Avatar } from 'antd'
import { splitUid, WeaverQuery, getRelationNode, getMemberKey, getMemberKeys, isBirthday } from 'Services/WeaverUtils'
import WeaverService from 'Services/WeaverService'
import GraphContextMenu from './GraphContextMenu'
import { setEditingNode, setTab, setCurrentItem, setTabDisabled, setDetailPopup } from 'Actions/explore'
import balloonIcon from 'Images/undraw_floating.svg'
import privateIcon from 'Images/undraw_safe_re_kiil.svg'
import birthdayHat from 'Images/birthday_hat.svg'
import './GraphViewContainer.scss'
import { setDarkModeEnabled } from 'Actions/explore'
import {
  getColorByGraph,
  loadGraphData,
  loadAbstractGraphData,
  loadAbstractRelationData,
  loadAbstractAttributeData,
  pinNode,
  expandNode,
  expandAbstractNode
  constructQueryFromEmbeddedGraphParams
} from 'Services/GraphUtils'
import {
  clearGraph
  removeGraphEdge
  setGraphAddingEdge
  setGraphCreatingEdge
  setGraphNodes
  setGraphShowingNode
  setGraphColorPickerProps
  setSelectedGraphItems
  updateGraphNodes
  setIsEmbeddedView
} from 'Actions/graph'
import {
  setFilteredNodesByOther
  resetFilteredNodes
  resetFilteredRelations
  resetGraphFilters
  resetRelationFilters
  setTypeFilters
  updateTypeFilter
  updateTypeFilters
} from 'Actions/graphFilter'
import {
  getFilteredTypes
  filterNodesByRelation
  filterNodesByType
} from 'Services/GraphFilterUtils'

GraphViewContainer = ({
  currentTab
  currentBranch
  clearGraph
  currentProject
  currentItem
  disabledRelations
  disabledTypes
  devtoolsEnabled
  graphData
  isHidden
  left
  removeGraphEdge
  resetFilteredNodes
  resetFilteredRelations
  resetGraphFilters
  resetRelationFilters
  setTypeFilters
  setCurrentItem
  setDetailPopup
  setEditingNode
  setFilteredNodesByOther
  setGraphAddingEdge
  setGraphColorPickerProps
  setGraphCreatingEdge
  setGraphNodes
  setGraphShowingNode
  setIsEmbeddedView
  setSelectedGraphItems
  setTab
  setTabDisabled
  showRelationsAsNodes
  tabIsLocked
  typesMap
  updateGraphNodes
  updateTypeFilter
  updateTypeFilters
  isEmbeddedView
  setDarkModeEnabled
  tabsDisabled
}) ->
  [loading, setLoading] = useState(false)
  [active, setActive] = useState(undefined)
  [locked, setLocked] = useState(tabIsLocked)
  [data, setData] = useState(currentItem)
  [viewType, setViewType] = useState(undefined)
  [memberKey, setMemberKey] = useState(getMemberKey())
  [threeDModeActive, setThreeDModeActive] = useState(false)
  [isPublic, setIsPublic] = useState(false)
  currentPendingQuery = useRef(undefined)
  isMounted = useComponentIsMountedRef()
  dispatch = useDispatch()

  params = useQuery()
  history = useHistory()
  { url, params: { spaceId } } = useRouteMatch()
  { hash }  = useLocation()

  mode = params.get('mode')
  if mode is 'dark'
    setDarkModeEnabled(true)

  setIsEmbeddedView(url is "/#{spaceId}/embedded")

  events =
    dragEnd: ({ nodes }) ->
      return unless id = nodes[0]
      updateGraphNodes(pinNode(graphData.nodes[id]))
    click: ({ nodes, edges }) ->
      setSelectedGraphItems(undefined)
      if isEmbeddedView
        return
      if id = nodes[0]
        node = graphData.nodes[id]
        setActive({
          node...
          type: NODE
        })
        if graphData.relNodes[id]?
          relation = await getRelationNode(id)
          setCurrentItem({
            relation
            type: RELATION
          })
        else if node.sources? or node.targets?
          return # TODO Handle relation view nodes
        else
          setCurrentItem({
            node...
            type: ATTRIBUTES
            memberKey
            viewType
          })
        unless tabIsLocked or (currentTab is 'attributes')
          params.set('tab', 'attributes')
          history.replace({ pathname: url, search: params.toString(), hash })
          setTab('attributes')
      else if rel = edges[0]
        setActive({
          rel
          type: RELATION
          viewType
        })

        if viewType isnt VIEWTYPE.ABSTRACT
          relation = await getRelationNode(rel)
        else
          relation = graphData.edges[rel]

        return if relation.noAttributes

        setCurrentItem({
          relation
          type: RELATION
          viewType
        })
        unless tabIsLocked or (currentTab is 'attributes')
          params.set('tab', 'attributes')
          history.replace({ pathname: url, search: params.toString(), hash })
          setTab('attributes')
      else
        setGraphAddingEdge(false)
        setGraphShowingNode(undefined)
        setGraphColorPickerProps(undefined)

      setTabDisabled({ key: 'attributes', disabled: false }) if (id and tabsDisabled.attributes)
    doubleClick: ({ nodes }) ->
      return unless id = nodes[0]
      if viewType isnt VIEWTYPE.ABSTRACT
        expanded = await expandNode(id)
      else
        expanded = await expandAbstractNode(id)
      updateGraphNodes(expanded)

  onRightClick = ({ event, nodes, edges, pointer, target, network }) ->
    if isEmbeddedView
      return
    if target is NODE
      setActive({
        nodes
        type: NODE
        event
        network
      })
    else if target is RELATION
      setActive({
        edges
        nodes
        type: RELATION
        event
        network
      })
    else
      setActive(undefined)

  useEffect( ->
    clearGraph()
    undefined
  , [currentProject])

  useEffect( ->
    ( ->
      if url is "/#{spaceId}/embedded"
        currProj = await Weaver.Project.load(spaceId)
        acl = await currProj.getACL()
        spaceIsPublic = await acl.getPublicReadAccess()
        if spaceIsPublic
          setData({
            type: 'QUERY'
            data: {
              query: constructQueryFromEmbeddedGraphParams(params)
            }
            ranAt: new Date().getMilliseconds()
          })
        else
         setIsPublic(false)
         setData({})
      else
        setData(currentItem)
    )()
    undefined
  , [currentItem])

  useEffect( =>
    query = undefined
    if data.type is 'QUERY'
      setGraphAddingEdge(false)
      query = data.data.query
      setViewType(data.data.viewType)
      setMemberKey(data.data.memberKey or getMemberKey())
      runGraphQuery(query, undefined, data.data.viewType is VIEWTYPE.ABSTRACT, data.data.memberKey)
    else if data.type is NODE
      [id, graph] = splitUid(data.id)
      query = new WeaverQuery()
        .restrict([id])
        .inGraph(graph)
        .selectOut('*')
        .selectIn('*')
        .selectOutMinus(disabledRelations...)
        .selectInMinus(disabledRelations...)
      setViewType(data.viewType)
      runGraphQuery(query, data.id, data.viewType is VIEWTYPE.ABSTRACT, data.memberKey)
    else if data.type is RELATION_VIEW or data.type is ATTRIBUTE_VIEW
      setViewType(data.viewType)
      runGraphQuery(null, data.id, data.viewType is VIEWTYPE.ABSTRACT, null, data.type)
    undefined
  , [data, currentBranch])

  filterDisabledGraphItems = ->
    dispatch(await filterNodesByRelation())
    dispatch(await filterNodesByType())

  resetFilters = ->
    { nodes } = graphData
    memberKeys = getMemberKeys()
    types = await getFilteredTypes({
      nodes,
      memberKeys,
      selectedItems: disabledTypes,
      types: _.values(typesMap)
    })
    dispatch(setTypeFilters(types))
    resetGraphFilters()
    resetRelationFilters()

  getColoredGraphData = (data) ->
    if JSON.parse(localStorage.getItem("colorByGraph"))
      data = { data..., getColorByGraph(data.nodes)... }
    data

  runGraphQuery = (query, id, abstract, memberKey, type) ->
    setLoading(true)
    await resetFilters()
    resetFilteredNodes()
    resetFilteredRelations()
    setGraphAddingEdge(false)
    setGraphCreatingEdge(undefined)
    setGraphColorPickerProps(undefined)
    setGraphShowingNode(undefined)
    currentPendingQuery.current?.cancel()
    if type is RELATION_VIEW
      promise = useCancelable(loadAbstractRelationData(id))
    else if type is ATTRIBUTE_VIEW
      promise = useCancelable(loadAbstractAttributeData(id))
    else if abstract
      promise = useCancelable(loadAbstractGraphData(id, memberKey))
    else
      promise = useCancelable(loadGraphData(query, id))
    currentPendingQuery.current = promise
    loadedGraphData = await promise
    coloredGraphData = getColoredGraphData(loadedGraphData)
    setGraphNodes(coloredGraphData)
    await filterDisabledGraphItems()
    setLoading(false)
    setActive(undefined)



  <>
    <GraphContextMenu data={{ graphData, active }}>
      {
        if loading
          <Loading style={{ stroke: 'rgb(229, 234, 236)' }} />
        else if _.values(graphData.nodes)?[0]? && !isHidden
          if threeDModeActive
            <WeWeVr data={graphData} goToTwoDMode={-> setThreeDModeActive(false)} />
          else
            <div data-testid="graph-container">
              <Graph
                options={{
                  physics: {
                    forceAtlas2Based: {
                      gravitationalConstant: if viewType is VIEWTYPE.ABSTRACT then -75 else -50
                    }
                  }
                }}
                events={events}
                tabIsLocked={tabIsLocked}
                style={{ height: '100vh' }}
                data={graphData}
                contextMenuCb={onRightClick}
                goToThreeDMode={-> setThreeDModeActive(true)}
              />
            </div>
        else
          <div
            data-testid="empty-graph-container"
            className="graph-embossed-logo-container"
          >
            <div>
              <Avatar src={if isEmbeddedView and not isPublic then privateIcon else balloonIcon} style={{ width: 340, height: 280 }} />
              {
                if isBirthday()
                  <img src={birthdayHat}
                    style={{
                      position: 'absolute'
                      width: '9px'
                      left: '221px'
                      top: '217px'
                      zIndex: 1
                      transform: 'rotate(39deg)'
                    }}
                  />
              }
            </div>
          </div>
      }
    </GraphContextMenu>
    { if devtoolsEnabled and currentProject? and currentBranch?
      <GraphConsole left={left} isHidden={isHidden} />
    }
  </>

export default connect(({ graph, graphFilter, explore, projects, branches }) ->
  {
    disabledTypes: explore.disabledTypes
    disabledRelations: explore.disabledRelations
    darkModeEnabled: explore.darkModeEnabled
    graphData: graph.graphData
    currentItem: explore.currentItem,
    currentTab: explore.currentTab
    tabIsLocked: explore.tabIsLocked,
    typesMap: explore.typesMap
    currentProject: projects.currentProject
    showRelationsAsNodes: graphFilter.showRelationsAsNodes
    devtoolsEnabled: graph.devtoolsEnabled
    currentBranch: branches.currentBranch
    isEmbeddedView: graph.isEmbeddedView
    tabsDisabled: explore.tabsDisabled
  }
, {
  clearGraph
  removeGraphEdge
  resetFilteredNodes
  resetFilteredRelations
  resetGraphFilters
  resetRelationFilters
  setTypeFilters
  setCurrentItem
  setDetailPopup
  setEditingNode
  setFilteredNodesByOther
  setGraphAddingEdge
  setGraphCreatingEdge
  setGraphColorPickerProps
  setGraphNodes
  setGraphShowingNode
  setSelectedGraphItems
  setIsEmbeddedView
  setTab
  setTabDisabled
  updateGraphNodes
  updateTypeFilter
  updateTypeFilters
  setDarkModeEnabled
})(GraphViewContainer)
